<template>
  <div class="wc-page-wrapper">
    <!-- START : Product Details Wrap -->
    <div v-if="item" class="row">
      <WCImageGallery class=" col-xs-12 col-sm-5" :item="item" />

      <!-- START : Product Description Wrap -->
      <div id="item-details" class="col-xs-12 col-sm-7">
        <h1 class="name font-weight-bold" :id="item.id">
          {{ item.name
          }}<span class="alternate-name" v-if="item.alternateName">
            - {{ item.alternateName }}</span
          >
        </h1>
        <div class="font-size-lg text-primary">{{ item.brand }}</div>

        <div class="d-flex my-3">
          <WCProductPricing :item="item" class="font-size-xl" />
          <div class="d-flex flex-column align-items-end flex-grow-1">
            <WCBasicAddToCartButton
              :item="item"
              class="btn-block w-50 mb-3"
              :describedBy="item.id"
              v-if="!isCustomerModeScan && $configuration.cartEnabled"
            />
            <!-- START : Add to list button -->
            <template>
              <WCAddToListButton
                :item="item"
                v-if="
                  (!item.hasModifiers && !item.hasLinkedItems) ||
                    (!item.hasModifiers && !item.hasLinkedItems && !$configuration.cartEnabled)
                "
              />
              <div
                v-else-if="
                  item.hasModifiers ||
                    item.hasLinkedItems ||
                    (item.hasModifiers && !$configuration.cartEnabled) ||
                    (item.hasLinkedItems && !$configuration.cartEnabled)
                "
              >
                <button
                  class="btn btn-link underline-link-from-center p-0"
                  @click="customizeItemToAddToList()"
                  ref="customizeBtnRef"
                >
                  {{ $t('customizeAndAddToList')
                  }}<font-awesome-icon class="ml-2" icon="list-check" />
                </button>
              </div>
            </template>
            <!-- END : Add to list button -->
          </div>
        </div>

        <!-- START : Product Description Tab -->
        <WCTabNav
          :ariaLabel="$t('productInfo')"
          class="tabs-panel font-size-sm"
          @selected="selectedTab = $event"
          :tabs="tabs"
        >
          <WCTab :title="$t('details')" :selected="$t('details') === selectedTab">
            <WCProductDetails :item="item" :custom="detailsCustomContent" />
          </WCTab>
          <WCTab
            v-for="cs in customSourcesMinusDuplicates"
            :key="cs.id"
            :title="cs.label"
            :selected="cs.label === selectedTab"
          >
            <WCCustomContent :content="cs.content"></WCCustomContent>
          </WCTab>
          <WCTab
            v-if="
              (item.nutrition && item.nutrition.length > 0) ||
                item.ingredients ||
                nutritionCustomContent
            "
            :title="$t('nutrition')"
            :selected="$t('nutrition') === selectedTab"
          >
            <WCNutritionFacts
              v-if="item.nutrition && item.nutrition.length > 0"
              :item="item"
            ></WCNutritionFacts>
            <div v-if="item.ingredients">
              <b>{{ $t('ingredients') }}:</b> {{ item.ingredients }}
            </div>
            <div class="pt-3" v-if="nutritionCustomContent">
              <WCCustomContent :content="nutritionCustomContent.content" />
            </div>
          </WCTab>
          <WCTab :title="$t('disclaimer')" :selected="$t('disclaimer') === selectedTab">
            <div>
              <b>{{ $t('disclaimer') }}: </b>
              {{ $t('disclaimerText') }}
              {{ $configuration.store.name }} {{ $t('assumesNoLiability') }}
            </div>
            <div class="pt-3" v-if="disclaimerCustomContent">
              <WCCustomContent :content="disclaimerCustomContent.content" />
            </div>
          </WCTab>
        </WCTabNav>
        <!-- END : Product Description Tab -->

        <WCAlternateItems class="pt-3" :item="item" :showAddToCartButton="!isCustomerModeScan" />
      </div>
      <!-- END : Product Description Wrap -->
    </div>
    <!-- END : Product Details Wrap -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import WCAddToListButton from '@/modules/lists/components/WCAddToListButton/WCAddToListButton.vue';
import WCImageGallery from '@/components/WCImageGallery/WCImageGallery.vue';
import WCTabNav from '@/components/WCTabNav/WCTabNav.vue';
import WCTab from '@/components/WCTab/WCTab.vue';
import WCNutritionFacts from '@/components/WCNutritionFacts/WCNutritionFacts.vue';
import WCCustomContent from '@/components/WCCustomContent/WCCustomContent.vue';
import WCProductDetails from '@/components/WCProductDetails/WCProductDetails.vue';
import WCProductPricing from '@/components/WCProductPricing/WCProductPricing.vue';
import CartControlsMixin from '@/modules/cart/mixins/CartControls/CartControls';
import CartControlPropsMixin from '@/modules/cart/mixins/CartControls/CartControlsProps';
import WCBasicAddToCartButton from '@/modules/cart/components/WCBasicAddToCartButton/WCBasicAddToCartButton.vue';
import WCAlternateItems from '@/components/WCAlternateItems/WCAlternateItems.vue';
import ProductDetailMixin from './mixins/ProductDetailMixin';

export default {
  components: {
    WCImageGallery,
    WCTabNav,
    WCTab,
    WCNutritionFacts,
    WCCustomContent,
    WCProductDetails,
    WCAddToListButton,
    WCProductPricing,
    WCAlternateItems,
    WCBasicAddToCartButton,
  },
  mixins: [ProductDetailMixin, CartControlsMixin, CartControlPropsMixin],
  computed: {
    ...mapGetters({
      isGuest: 'user/isGuest',
      isCustomerModeScan: 'user/isCustomerModeScan',
    }),
  },
  data() {
    return {
      hasTabArrangement: true, // true|false to check if the tab has to be arranged.
    };
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.wc-page-wrapper {
  min-height: rem(500px);
}

.tabs-panel {
  margin-top: $margin-3;

  .tab-content {
    padding: $pad-3 $pad-2;
  }
}
</style>
